<template>
    <Popup title="Create new A/B page variation" class="create-ab-variant-popup" @close="closePopup()">
        <template v-slot:content>
            <label class="form_steps_label step_1">
                <span class="icon"></span> Select a template to clone or start from scratch
            </label>

	        <step-templates :source-page="sourcePage" @selectedPage="sourcePageId=$event" @selected="selectTemplate($event)" />

<!--            <div class="funnel_type_radio_wrpr" :class="{'active': step == 1}">-->
<!--              <div class="row">-->
<!--                <div class="col margin-rl-20" style="">-->
<!--                  <SelectButton :value="false" no-icon-->
<!--                                v-model="newData.is_subscription"-->
<!--                                label="Clone main page">-->
<!--                  </SelectButton>-->
<!--                </div>-->
<!--                <div class="col margin-rl-20">-->
<!--                  <SelectButton :value="true" no-icon v-model="newData.is_subscription"-->
<!--                                label="Create new page from template" />-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
        </template>

        <template v-slot:actions>
          <v-button @click="closePopup" label="Cancel" border />
          <v-button @click="clonePage" label="Continue" :loading="saving" />
        </template>
    </Popup>

</template>

<script>
import API from "@/api"
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";
import StepTemplates from "@/views/funnels/funnel-plus/steps/templates";

export default {
    name: "CreateABVariantPopup",
    components: {
	    StepTemplates,
	    VButton,
      Popup
    },
    mixins: [API],
    props: ['sourcePage', 'step'],
    data() {
        return {
        	saving: false,
	        sourcePageId: 1,
	        sourceTemplateId: 1,
          continueBtnDisabled: true,
	        isUserTemplate: false,
          newData: {
            "name": '',
            "price": 0,
          },

        }
    },
  computed: {
  },
  methods: {
	  selectTemplate(id) {
		  if ((''+id).startsWith('U.')) {
			  this.sourceTemplateId = parseInt(id.replace('U.',''));
			  this.isUserTemplate = true;
		  } else {
			  this.isUserTemplate = false;
			  this.sourceTemplateId = id;
		  }
	  },
	  async clonePage() {
		  try {
			  this.saving = true
			  let newPage = {};

			  if (this.sourceTemplateId === -1) { // same user template then clone it.
				  newPage = await this.api.wsteps.clonePage(this.sourcePage.funnel_id, this.sourcePage.step_id, this.sourcePageId);
			  } else { // different user template then create empty page, then apply template
				  newPage = await this.api.wsteps.createPage(this.sourcePage.funnel_id, this.sourcePage.step_id, {
					  name:this.sourcePage.name + ' ' + Date.now(),
					  step_id:this.sourcePage.step_id,
					  funnel_id:this.sourcePage.funnel_id,
					  template_id:this.sourceTemplateId,
					  path:this.sourcePage.path,
					  url:this.sourcePage.url,
					  domain_name:this.sourcePage.domain_name,
					  domain_id:this.sourcePage.domain_id,
					  seo_title:this.sourcePage.seo_title,
					  seo_description:this.sourcePage.seo_description,
					  ab_type:this.sourcePage.ab_type,
					  ab_geo:this.sourcePage.ab_geo,
					  ab_percent:0,
					  order_index:this.step.pages.length,
				  }, this.isUserTemplate);
					if (newPage.error) throw newPage;
					// if (this.sourceTemplateId > 1) { // if a non-empty template selected
					// 	let result = await this.api.wsteps.applyTemplate(this.sourcePage.funnel_id, this.sourcePage.step_id, newPage.id, this.sourceTemplateId);
					// 	if (result.error) throw result; // <-- this is not a page.
					// }
			  }
			  this.step.pages.push(newPage);
			  this.$emit('close');
		  } catch (e) {
			  this.$error(e);
		  } finally {
			  this.saving = false
		  }
	  },
    closePopup() {
        this.$emit("close");
    },
  },
  created(){
  },
}
</script>
<style lang="scss" >
.create-ab-variant-popup {
	.popup {
		max-width: 1000px;
	}
}
.funnel_details_step {
  .product-name {
    margin-bottom: 20px;
  }
}
</style>
